export { default } from './PhoneNumberQuizStep';
